export const defaultWidth = 20;
export const defaultHeight = 20;
export const offset = 15;
export const defaultRadius = 5;
export const offsetActivityY = 50;
export const offsetRefinementX = 40;
export const offsetRefinementY = 20;
export const spacing = 20;
export const lastStateOffset = 40;
